export default {"src":"/_next/static/media/houseAndPerson_64.6c3d47fb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};